export default __webpack_public_path__ + "static/media/1459.2aa39ccc.png";